<template>
    <div>
        <div v-if="typebusiness=='bloodtestlaboratory' || typebusiness=='medicalclinic'">
            <div class="d-flex justify-space-around my-3">
                <h5 class="mx-3" ><b>ID:</b> {{ customerToShow.ID_Customer }}</h5>
                <h5 class="mx-3" ><b>Cliente:</b> {{customerToShow.FirstName}} {{customerToShow.LastName}}</h5>
            </div>

      <v-divider></v-divider>

      <div class="patients-to-client">
        <div style="display: flex; justify-content: space-between">
          <h2 class="mb-4">Pacientes vinculados al cliente</h2>
          <!--v-btn  class="text-uppercase btnclean" @click.prevent="getPatients()">
                    Recargar pacientes
                </v-btn-->
        </div>
        <br />
        <GeneralFilter
          entity="lista"
          :filterEndpoint="$API.patients.getPatientsFiltered"
          :search="search"
          @emptyFilter="getPatients"
          @filtered="filterHandlerPatients"
        >
          <DxDataGrid class="isScrolledByGeneralFilter"
            id="gridContainer"
            :data-source="patients"
            :show-borders="true"
            key-expr="ID_Patient"
          >
            <DxPaging :page-size="10" />
            <DxScrolling row-rendering-mode="virtual" />
            <DxColumn data-field="ID_Patient" caption="ID" />
            <DxColumn data-field="FirstName" caption="Nombre" />
            <DxColumn data-field="LastName" caption="Apellido" />
            <DxColumn data-field="NotificationMobile" caption="Télefono" />
            <DxColumn
              data-field="NotificationEmail"
              caption="Correo eléctronico"
            />
            <!--DxColumn data-field="Gender">
                        <DxLookup
                                :data-source="gender"
                                display-expr="Name"
                                value-expr="ID"
                        />
                    </DxColumn-->
            <!--DxColumn data-field="DateOfBirth"
                            caption="Birth Date"
                            data-type="date"/-->

            <!--DxColumn data-field="Age"/-->
            <DxColumn data-field="Address" caption="Dirección" />
            <!--DxColumn data-field="City"/>
                    <DxColumn data-field="State"/-->
            <DxColumn data-field="Country" caption="País" />
            <DxColumn :width="200" data-field="OldID" caption="Código alterno"></DxColumn> 
            <DxColumn
              :width="120"
              cell-template="show-template"
              caption=""
              v-if="$store.getters['rolesUser/getCustomRole'](84)"
            ></DxColumn>
            <template #show-template="{ data }">
              <a href="#" class="mx-1" @click="patientSelected(data)">
                <v-icon color="primary">mdi-eye</v-icon>
              </a>
            </template>
          </DxDataGrid>
        </GeneralFilter>

        <div class="d-flex justify-center text-center" style="gap: 50px;">
          <v-btn class="btn-save" v-if="$store.getters['rolesUser/getCustomRole'](83)" large @click.prevent.stop="addPatients()">
            Añadir nuevo paciente
          </v-btn>
          <v-btn class="btn-save" v-if="$store.getters['rolesUser/getCustomRole'](83)" large @click.prevent.stop="handleShowCustomersList('medical')">
            Migrar pacientes
          </v-btn>
        </div>
      </div>
    </div>

    <!--VETERINARY PATIENTS-->
    <div v-if="typebusiness == 'veterinary'">
      <div class="d-flex justify-space-around my-3">
        <h3 class="mx-3">ID de Cliente: {{ customerToShow.ID_Customer }}</h3>
        <h3 class="mx-3">
          Nombre de Cliente: {{ customerToShow.FirstName }}
          {{ customerToShow.LastName }}
        </h3>
      </div>

      <v-divider></v-divider>

      <div class="patients-to-client">
        <p class="mb-4">Pacientes de la veterinaria vinculado al cliente</p>
        <div class="d-flex justify-end" style="gap: 50px;">
          <div class="text-center">
            <v-btn
              color="btn-save"
              dark
              large
              v-if="$store.getters['rolesUser/getCustomRole'](83)"

              @click.prevent.stop="addVeterinaryPatients()"
            >
              Añadir nuevo paciente
            </v-btn>
          </div>
          <div class="text-center">
            <v-btn
              color="btn-save"
              dark
              large
              v-if="$store.getters['rolesUser/getCustomRole'](83)"
              @click.prevent.stop="handleShowCustomersList('veterinary')"
            >
              Migrar pacientes
            </v-btn>
          </div>
          <div class="text-center">
            <v-btn
              dark
              color="light-blue darken-1"
              class="text-uppercase"
              large
              @click.prevent="getVeterinaryPatients()"
              >
              Recargar pacientes
            </v-btn>
          </div>
          <div class="text-center">
            <v-btn
              class="btn-save"
              dark
              large
              v-if="$store.getters['rolesUser/getCustomRole'](83)"
              :disabled="veterinaryClinicSelectedPatients.length === 0"
              @click.prevent.stop="openVeterinaryClinicModal"
            >
              Actualmente en clínica
            </v-btn>
          </div>
        </div>
        <GeneralFilter
          entity="lista"
          :filterEndpoint="$API.veterinarypatients.getPatientsFiltered"
          :search="search"
          @emptyFilter="getVeterinaryPatients"
          @filtered="filterHandlerVeterinaryPatients"
        >
          <DxDataGrid class="isScrolledByGeneralFilter"
            id="gridContainer"
            :data-source="veterinarypatients"
            :selected-row-keys="veterinaryClinicSelectedPatientIds"
            :show-borders="true"
            key-expr="ID_Patient"
            @selection-changed="onVeterinaryClinicSelectionChanged"
            @editing-start="logEvent('EditingStart')"
            @init-new-row="logEvent('InitNewRow')"
            @row-inserting="logEvent('RowInserting')"
            @row-inserted="logEvent('RowInserted')"
            @row-removing="logEvent('RowRemoving')"
            @row-removed="rowRemoved($event)"
            @saving="logEvent('Saving')"
            @saved="dataSaved"
          >
            <DxPaging :enabled="false" />
            <DxSelection mode="multiple" :show-check-boxes-mode="'always'" :allow-select-all="true" :select-all-mode="'allPages'" />
            <DxColumn
              :width="80"
              cell-template="show-template"
              caption=""
            v-if="$store.getters['rolesUser/getCustomRole'](84)"

            ></DxColumn>
            <DxColumn data-field="ID_Patient" caption="ID" />
            <DxColumn data-field="NamePatient" caption="Paciente" />
            <DxColumn data-field="Gender" caption="Sexo" />
            <DxColumn data-field="Species" caption="Especíe" />
            <DxColumn data-field="Breed" caption="Raza" />
            <DxColumn data-field="Weight" caption="Peso" />
            <DxColumn
              data-field="NotificationMobile"
              caption="Número del cliente"
            />
            <DxColumn
              data-field="NotificationEmail"
              caption="Correo del cliente"
            />
            <DxColumn data-field="OldID" caption="Código alterno"></DxColumn> 
            <DxColumn
              caption="Fallecido"
              :width="120"
              cell-template="live-template"
            />
            <DxColumn
              caption="Estado"
              :width="140"
              cell-template="status-template"
            />
            <DxColumn
            v-if="$store.getters['rolesUser/getCustomRole'](85)"
              :width="60"
              cell-template="show-delete"
              caption=""
            ></DxColumn>
            <template #show-template="{ data }">
              <div class="d-flex align-center justify-center">
                <a href="#" class="mx-1" @click="veterinaryPatientSelected(data)">
                  <v-icon color="primary">mdi-eye</v-icon>
                </a>
                <v-tooltip bottom>
                  <template #activator="{ on, attrs }">
                    <a
                      href="#"
                      class="mx-1"
                      v-bind="attrs"
                      v-on="on"
                      @click.prevent.stop="openUpcomingVaccinesModal(data.data)"
                    >
                      <v-icon color="primary">mdi-archive-clock</v-icon>
                    </a>
                  </template>
                  <span>Proxima Vacuna</span>
                </v-tooltip>
              </div>
            </template>
            <template #show-delete="{ data }">
              <a href="#" class="mx-1" @click="confirmDelete(data)">
                <v-icon color="error">mdi-delete</v-icon>
              </a>
            </template>
            <template #live-template="{ data }">
              <v-chip
                x-small
                dark
                :color="getVeterinaryPatientLiveColor(data.data)"
              >
                {{ getVeterinaryPatientLiveLabel(data.data) }}
              </v-chip>
            </template>
            <template #status-template="{ data }">
              <v-chip
                x-small
                dark
                :color="getVeterinaryPatientStatusColor(data.data)"
              >
                {{ getVeterinaryPatientStatusLabel(data.data) }}
              </v-chip>
            </template>
          </DxDataGrid>
        </GeneralFilter>
      </div>
    </div>
    <v-dialog v-model="showCustomersList" width="80%">
      <v-card flat class="pa-1" rounded="lg">
        <v-card-text class="pa-0">
          <GeneralFilter  class="background border-box" :filterEndpoint="$API.customers.filterCustomers" :search="{...searchCustomers, filteredFrom: 0 }" @emptyFilter="getAllCustomers" @filtered="filterHandler">
            <DxDataGrid class="isScrolledByGeneralFilter" :data-source="customers" key-expr="ID_Customer" :show-row-lines="true"
              :show-borders="true" :row-alternation-enabled="true">
  
              <DxScrolling row-rendering-mode="virtual" />
              <DxPaging :page-size="10" />
              <DxColumn :width="80" cell-template="select-template" v-if="$store.getters['rolesUser/getCustomRole'](78)"
               caption=""></DxColumn>
              <DxColumn data-field="ID_Customer" caption="ID"></DxColumn>
              <DxColumn data-field="customerNameToShow" caption="Nombre"></DxColumn>
              <DxColumn data-field="customerEmailToShow" caption="Correo"></DxColumn> 
              <DxColumn data-field="LegalName" caption="Nombre Legal"></DxColumn> 
              <template #select-template="{ data }">
                <a class="mx-1" @click="customerSelected(data.data.ID_Customer)">
                  <v-icon color="primary">mdi-swap-horizontal-circle</v-icon>
                </a>
              </template>  
            </DxDataGrid>
          </GeneralFilter>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Mostrar y seleccionar pacientes a migrar -->
    <v-dialog v-model="showPatientsToMigrateModal" width="70%">
      <v-card flat class="pa-1" rounded="lg">
        <v-card-title>
          <span class="headline">Pacientes del cliente seleccionado</span>
        </v-card-title>
        <v-card-text>
          <GeneralFilter
            entity="lista"
            :filterEndpoint="patientsToMigrateFilterEndpoint"
            :search="patientsToMigrateSearch"
            @emptyFilter="fetchPatientsToMigrate"
            @filtered="filterHandlerPatientsToMigrate"
          >
            <div v-if="patientsToMigrateFiltered.length > 0">
              <div class="d-flex justify-end mb-2" style="gap: 10px;">
                <v-btn color="btn-save" @click="confirmMigratePatients">
                  Migrar todos los pacientes
                </v-btn>
                <v-btn
                  color="btn-save"
                  :disabled="selectedPatients.length === 0"
                  @click="confirmMigrateSelectedPatients"
                >
                  Migrar pacientes seleccionados
                </v-btn>
              </div>
              <DxDataGrid
                class="isScrolledByGeneralFilter"
                :data-source="patientsToMigrateFiltered"
                :show-borders="true"
                key-expr="ID_Patient"
                style="max-height: 400px;"
              >
                <DxPaging :page-size="10" />
                <DxScrolling row-rendering-mode="virtual" />
                <DxColumn
                  :width="60"
                  caption=""
                  cell-template="select-patient"
                />
                <!-- Columnas para tipo veterinary -->
                <DxColumn v-if="typebusiness == 'veterinary'" data-field="ID_Patient" caption="ID" />
                <DxColumn v-if="typebusiness == 'veterinary'" data-field="NamePatient" caption="Paciente" />
                <DxColumn v-if="typebusiness == 'veterinary'" data-field="Gender" caption="Sexo" />
                <DxColumn v-if="typebusiness == 'veterinary'" data-field="Species" caption="Especíe" />
                <DxColumn v-if="typebusiness == 'veterinary'" data-field="Breed" caption="Raza" />
                <DxColumn v-if="typebusiness == 'veterinary'" data-field="NotificationMobile" caption="Número del cliente" />
                <DxColumn v-if="typebusiness == 'veterinary'" data-field="NotificationEmail" caption="Correo del cliente" />
                <DxColumn v-if="typebusiness == 'veterinary'" data-field="OldID" caption="Código alterno" />
                <!-- Columnas para tipo medical -->
                <DxColumn v-if="typebusiness != 'veterinary'" data-field="ID_Patient" caption="ID" />
                <DxColumn v-if="typebusiness != 'veterinary'" data-field="FirstName" caption="Nombre" />
                <DxColumn v-if="typebusiness != 'veterinary'" data-field="LastName" caption="Apellido" />
                <DxColumn v-if="typebusiness != 'veterinary'" data-field="NotificationMobile" caption="Télefono" />
                <DxColumn v-if="typebusiness != 'veterinary'" data-field="NotificationEmail" caption="Correo eléctronico" />
                <DxColumn v-if="typebusiness != 'veterinary'" data-field="Address" caption="Dirección" />
                <DxColumn v-if="typebusiness != 'veterinary'" data-field="Country" caption="País" />
                <DxColumn v-if="typebusiness != 'veterinary'" :width="200" data-field="OldID" caption="Código alterno" />
                <template #select-patient="{ data }">
                  <v-checkbox
                    v-model="selectedPatients"
                    :value="data.data.ID_Patient"
                    hide-details
                    dense
                  />
                </template>
              </DxDataGrid>
              <div class="mt-2">
                <v-checkbox
                  v-model="selectAllPatients"
                  @change="toggleSelectAllPatients"
                  :label="'Seleccionar todos'"
                  hide-details
                  dense
                />
              </div>
            </div>
          </GeneralFilter>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closePatientsToMigrateModal">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ClinicPatientsModal
      v-model="showVeterinaryClinicModal"
      :clinic-patients-form="veterinaryClinicPatientsForm"
      :clinic-items="veterinaryClinicItems"
      :users="veterinaryClinicUsers"
      :selected-patients="veterinaryClinicSelectedPatients"
      :veterinary-mode="true"
      :weight-units="['Kg', 'Lb']"
      :loading="veterinaryClinicSaving"
      @close="closeVeterinaryClinicModal"
      @remove-patient="removeVeterinaryClinicPatient"
      @apply-global-assigned-to="applyVeterinaryAssignedToToAll"
      @update-patient-field="updateVeterinaryClinicPatientField"
      @save="saveVeterinaryClinicPatients"
    />
    <UpcomingVaccinesModal
      v-model="showUpcomingVaccinesModal"
      :patient="selectedUpcomingVaccinesPatient"
    />
    <alerts
      v-if="alert.show"
      v-on:close_alert="closeAlert"
      v-on:accept_alert="acceptAlert"
      :properties="alert"
    ></alerts>
  </div>
</template>

<script>
import GeneralFilter from "@/components/GeneralFilter";
import Alerts from "@/components/Alerts";
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  //DxEditing,
  DxPaging,
  DxSelection,
} from "devextreme-vue/data-grid";
import { bus } from "../../../main";
import { mapState } from "vuex";
import ClinicPatientsModal from "./ClinicPatientsModal.vue";
import UpcomingVaccinesModal from "@/components/veterinary/UpcomingVaccinesModal.vue";
export default {
  name: "Patients",
  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    //  DxEditing,
    Alerts,
    DxPaging,
    DxSelection,
    GeneralFilter,
    ClinicPatientsModal,
    UpcomingVaccinesModal,
  },
  props: ["customerToShow", "win"],
  watch: {
    customerToShow: {
      handler(newVal, oldVal) {
        console.log("Prop changed: ", newVal, " | was: ", oldVal);
        this.clearClinicSelection();
        this.clearVeterinaryClinicSelection();
        this.showClinicModal = false;
        this.showVeterinaryClinicModal = false;
        this.showUpcomingVaccinesModal = false;
        this.selectedUpcomingVaccinesPatient = null;
        if (this.typebusiness == "bloodtestlaboratory" || this.typebusiness == "medicalclinic") {
          this.getPatients();
          this.getClinicUsers();
        }
        if (this.typebusiness == "veterinary") {
          this.getVeterinaryPatients();
          this.getVeterinaryClinicUsers();
        }
      },
    },
  },
  data() {
    return {
      typebusiness: null,
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      /*For bloodtestlaboratory*/
      addPatient: false,
      patients: [],
      Confirmdata: {},
      gender: [
        {
          ID: "male",
          Name: "Male",
        },
        {
          ID: "female",
          Name: "Female",
        },
      ],
      selectTextOnEditStart: true,
      startEditAction: "click",

      /*For veterinary */
      veterinarypatients: {},

      showCustomersList: false,
      customers: [],
      searchCustomers: {},
      customerToMigrate: null,

      /*For filter*/
      search: {
        filter: null,
      },
      patientsToMigrate: [],
      patientsToMigrateFiltered: [],
      patientsToMigrateSearch: {
        customerID: null,
        filter: null,
      },
      patientsToMigrateFilterEndpoint: null,
      selectedPatients: [],
      selectAllPatients: false,
      selectAllVeterinaryPatients: false,
      showPatientsToMigrateModal: false,
      showClinicModal: false,
      clinicSaving: false,
      clinicPatientsForm: {
        VisitData: null,
        AsignedTo: null,
        Status: "Espera",
      },
      clinicItems: [
        "Consulta",
        "Control",
        "Cirugia",
        "Otro",
      ],
      veterinaryClinicItems: [
        "",
        "Consulta",
        "Control",
        "Cirugia",
        "Cumplimiento",
        "Curacion,Vendaje",
        "Rayos X, Ultrasonografia",
        "Vacunas, Pipeta o Desparasitante",
        "Peluqueria",
        "Guarderia",
        "Hospitalizado",
        "Examenes toma de muestra",
        "Lectura de exámenes",
        "Tramite de viaje",
        "Otro",
      ],
      clinicUsers: [],
      clinicSelectedPatientIds: [],
      clinicSelectedPatients: [],
      showVeterinaryClinicModal: false,
      showUpcomingVaccinesModal: false,
      veterinaryClinicSaving: false,
      veterinaryClinicPatientsForm: {
        VisitData: null,
        AsignedTo: null,
        Status: "Espera",
      },
      veterinaryClinicUsers: [],
      veterinaryClinicSelectedPatientIds: [],
      veterinaryClinicSelectedPatients: [],
      selectedUpcomingVaccinesPatient: null,
    };
  },
  mounted() {
    this.$store.dispatch("rolesUser/getAllRoles");
    bus.$on("loadIt", () => {
      this.getVeterinaryPatients();
    });
    this.$emit("reloadData");
    this.typebusiness =
      JSON.parse(localStorage.getItem("user")).businesstype || "";

    if (this.typebusiness == "veterinary") {
      this.getVeterinaryPatients();
      this.getVeterinaryClinicUsers();
    }

    if(this.typebusiness == "bloodtestlaboratory" || this.typebusiness == "medicalclinic"){
      this.getPatients();
      this.getClinicUsers();
    }
            /*this.$API.patients.getPatients({customer: this.customerToShow.ID_Customer})
                .then(response => {
                    this.patients = response
                })*/
    this.searchCustomers.business = JSON.parse(localStorage.getItem("user")).businessid || ""
    this.searchCustomers.branch = JSON.parse(localStorage.getItem("user")).branch || ""
    //this.getAllCustomers();
  },
  computed: {
    ...mapState("rolesUser", {
      rolesStatus: (state) => state.roles,
    }),
  },
  methods: {
    closeAlert() {
      this.alert.show = false;

      
    },
    acceptAlert() {
      this.alert.show = false;

      if (this.alert.options == "deletePatient") {
        this.checkBusniees(this.Confirmdata);
      }
      if (this.alert.options == "migratePatients" || this.alert.options == "migrateAllPatients") {
        this.migratePatients();
      }
      if (this.alert.options == "migrateSelectedPatients") {
        this.migrateSelectedPatients();
      }
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    confirmDelete(data){
      this.showAlert('question','Eliminar' ,'¿Está seguro de eliminar este paciente?', 'deletePatient');
      this.Confirmdata = data;
    },
    checkBusniees(data) {

      JSON.parse(localStorage.getItem("user")).businesstype == "veterinary"
        ? this.rowRemoved(data)
        : this.rowRemoved2(data);
      this.rowRemoved2(data);
    },
    reloadData(payload) {
      this.$emit("reloadData", payload);
    },

    /*methods for bloodtestlaboratory*/
    logEvent() {},
    rowRemoved(event) {
      let patient_id = event.data.ID_Patient;
      this.$API.veterinarypatients
        .logicalDeletePatient(patient_id)
        .then(() => {
          this.$emit("reloadData");
          this.showAlert(
            "success",
            "Paciente eliminado",
            "El paciente ha sido eliminado correctamente"
          );
          this.getVeterinaryPatients();
          /*  this.$toasted.success(response.message) */
        })
        .catch((err) => {
          console.log(err);
          this.showAlert("danger", "Error", "Ocurrio un error al eliminar el paciente");
        });
    },
    rowRemoved2(event) {
      let patient_id = event.data.ID_Patient;
      this.$API.patients.logicalDeletePatient(patient_id)
        .then(() => {
        // console.log();
          this.$emit("reloadData");
          this.showAlert(
            "success",
            "Paciente eliminado",
            "El paciente ha sido eliminado correctamente"
          );
          this.getPatients();
          /*  this.$toasted.success(response.message) */
        })
        .catch((err) => {
          console.log(err);
          this.showAlert("danger", "Error", "Ocurrio un error al eliminar el paciente");
        });
      },
    dataSaved() {
      // console.log(this.patients)
    },
    addPatientToCustomer() {
      this.addPatient = true;
    },

    /*methods for veterinary*/
    getVeterinaryPatients() {
      this.search.customerID = this.customerToShow.ID_Customer;
      this.$API.veterinarypatients
        .getPatientsHistory({ customer: this.customerToShow.ID_Customer })
        .then((response) => {
          this.veterinarypatients = response;
        });
    },

    getPatients() {
      this.search.customerID = this.customerToShow.ID_Customer;
      this.$API.patients
        .getPatientsHistory({ customer: this.customerToShow.ID_Customer })
        .then((response) => {
          this.patients = response;
        });
    },

    addVeterinaryPatients() {
      this.$store
        .dispatch("deleteWindowByUuid", { uuid: this.win.uuid })
        .then(() => {
          this.$store.dispatch("addWindow", {
            name: "VeterinaryPatientAdd",
            component: "VeterinaryPatientAdd",
            unique: true,
            meta: { customerToShow: this.customerToShow },
          });
        });
    },

    addPatients() {
      this.$store
        .dispatch("deleteWindowByUuid", { uuid: this.win.uuid })
        .then(() => {
          this.$store.dispatch("addWindow", {
            name: "AddPatient",
            component: "AddPatient",
            unique: true,
            meta: { customerToShow: this.customerToShow },
          });
        });
    },

    async getClinicUsers() {
      try {
        const response = await this.$API.users.getUsersByBranch();
        this.clinicUsers = [""];
        for (const user of response) {
          this.clinicUsers.push(`${user.FirstName} ${user.LastName} (${user.UserName})`);
        }
      } catch (e) {
        console.log(e);
        this.clinicUsers = [""];
      }
    },

    async getVeterinaryClinicUsers() {
      try {
        const response = await this.$API.users.getUsersByBranch();
        this.veterinaryClinicUsers = [""];
        for (const user of response.filter(this.isDoctorUser)) {
          this.veterinaryClinicUsers.push(this.formatDoctorOption(user));
        }
      } catch (e) {
        console.log(e);
        this.veterinaryClinicUsers = [""];
      }
    },

    isDoctorUser(user) {
      return user?.IsDoctor === true || user?.IsDoctor === 1 || user?.IsDoctor === '1';
    },

    formatDoctorOption(user) {
      return `${user.FirstName} ${user.LastName} (${user.UserName})`;
    },

    getDefaultVeterinaryWeightUnit() {
      try {
        const localparams = JSON.parse(localStorage.getItem("localparams")) || null;
        if (localparams && localparams.weightunit) {
          return localparams.weightunit;
        }
      } catch (e) {
        console.log(e);
      }

      try {
        const branch = JSON.parse(localStorage.getItem("branch")) || null;
        if (branch && branch.weightunit) {
          return branch.weightunit;
        }
      } catch (e) {
        console.log(e);
      }

      return "Kg";
    },

    isClinicPatientSelected(patientId) {
      return this.clinicSelectedPatientIds.includes(patientId);
    },

    toggleClinicPatientSelection(patient) {
      const patientId = patient.ID_Patient;
      const index = this.clinicSelectedPatientIds.indexOf(patientId);

      if (index === -1) {
        this.clinicSelectedPatientIds.push(patientId);
        this.clinicSelectedPatients.push({ ...patient });
        return;
      }

      this.clinicSelectedPatientIds.splice(index, 1);
      const patientIndex = this.clinicSelectedPatients.findIndex(
        (item) => item.ID_Patient === patientId
      );

      if (patientIndex !== -1) {
        this.clinicSelectedPatients.splice(patientIndex, 1);
      }
    },

    removeClinicPatient(patientId) {
      const idIndex = this.clinicSelectedPatientIds.indexOf(patientId);
      if (idIndex !== -1) {
        this.clinicSelectedPatientIds.splice(idIndex, 1);
      }

      const patientIndex = this.clinicSelectedPatients.findIndex(
        (item) => item.ID_Patient === patientId
      );

      if (patientIndex !== -1) {
        this.clinicSelectedPatients.splice(patientIndex, 1);
      }
    },

    onVeterinaryClinicSelectionChanged(e) {
      const selectedKeys = e.selectedRowKeys || [];
      const selectedRowsData = e.selectedRowsData || [];
      const previousSelected = new Map(
        this.veterinaryClinicSelectedPatients.map((patient) => [patient.ID_Patient, patient])
      );

      this.veterinaryClinicSelectedPatientIds = [...selectedKeys];
      this.veterinaryClinicSelectedPatients = selectedKeys.map((patientId) => {
        if (previousSelected.has(patientId)) {
          return previousSelected.get(patientId);
        }

        const row =
          selectedRowsData.find((item) => item.ID_Patient === patientId) ||
          (Array.isArray(this.veterinarypatients)
            ? this.veterinarypatients.find((item) => item.ID_Patient === patientId)
            : null) ||
          {};

        return {
          ...row,
          AsignedTo: this.veterinaryClinicPatientsForm.AsignedTo || "",
          Weight: row.Weight || row.weight || "",
          weightunit: row.weightunit || this.getDefaultVeterinaryWeightUnit(),
        };
      });
    },

    removeVeterinaryClinicPatient(patientId) {
      this.veterinaryClinicSelectedPatientIds = this.veterinaryClinicSelectedPatientIds.filter(
        (id) => id !== patientId
      );
      this.veterinaryClinicSelectedPatients = this.veterinaryClinicSelectedPatients.filter(
        (item) => item.ID_Patient !== patientId
      );
    },

    updateVeterinaryClinicPatientField({ patientId, field, value }) {
      const patient = this.veterinaryClinicSelectedPatients.find(
        (item) => item.ID_Patient === patientId
      );

      if (!patient) {
        return;
      }

      patient[field] = value;
    },

    getVeterinaryPatientLiveLabel(patient) {
      return this.isVeterinaryPatientDeceased(patient) ? "Fallecido" : "Vivo";
    },

    getVeterinaryPatientLiveColor(patient) {
      return this.isVeterinaryPatientDeceased(patient) ? "error" : "success";
    },

    isVeterinaryPatientDeceased(patient) {
      const liveValue = patient?.Live ?? patient?.live ?? 0;

      return Number(liveValue) === 1 || liveValue === true;
    },

    isVeterinaryPatientActive(patient) {
      const activeValue = patient?.Status ?? patient?.status ?? 0;

      return Number(activeValue) === 1 || activeValue === true;
    },

    getVeterinaryPatientStatusLabel(patient) {
      return this.isVeterinaryPatientActive(patient) ? "Activo" : "Inactivo";
    },

    getVeterinaryPatientStatusColor(patient) {
      return this.isVeterinaryPatientActive(patient) ? "success" : "gray";
    },

    normalizeVeterinaryPatientStatus(status) {
      return (status || "").toString().trim() || "Sin estado";
    },

    applyVeterinaryAssignedToToAll(assignedTo) {
      this.veterinaryClinicSelectedPatients = this.veterinaryClinicSelectedPatients.map((patient) => ({
        ...patient,
        AsignedTo: assignedTo,
      }));
    },

    async openClinicModal() {
      if (!this.clinicSelectedPatients.length) {
        this.showAlert(
          "warning",
          "Actualmente en clínica",
          "Selecciona al menos un paciente desde la grilla."
        );
        return;
      }

      if (!this.clinicUsers.length) {
        await this.getClinicUsers();
      }

      this.clinicPatientsForm = {
        VisitData: null,
        AsignedTo: null,
        Status: "Espera",
      };
      this.showClinicModal = true;
    },

    closeClinicModal() {
      this.showClinicModal = false;
    },

    async openVeterinaryClinicModal() {
      if (!this.veterinaryClinicSelectedPatients.length) {
        this.showAlert(
          "warning",
          "Actualmente en clínica",
          "Selecciona al menos un paciente desde la grilla."
        );
        return;
      }

      if (!this.veterinaryClinicUsers.length) {
        await this.getVeterinaryClinicUsers();
      }

      this.veterinaryClinicPatientsForm = {
        VisitData: null,
        AsignedTo: null,
        Status: "Espera",
      };
      this.veterinaryClinicSelectedPatients = this.veterinaryClinicSelectedPatients.map((patient) => ({
        ...patient,
        weightunit: patient.weightunit || this.getDefaultVeterinaryWeightUnit(),
        Weight: patient.Weight || patient.weight || "",
      }));
      this.showVeterinaryClinicModal = true;
    },

    closeVeterinaryClinicModal() {
      this.showVeterinaryClinicModal = false;
    },

    clearClinicSelection() {
      this.clinicSelectedPatientIds = [];
      this.clinicSelectedPatients = [];
    },

    clearVeterinaryClinicSelection() {
      this.veterinaryClinicSelectedPatientIds = [];
      this.veterinaryClinicSelectedPatients = [];
    },

    async saveClinicPatients() {
      if (!this.clinicSelectedPatients.length) {
        this.showAlert(
          "warning",
          "Actualmente en clínica",
          "Selecciona al menos un paciente para guardar la visita."
        );
        return;
      }

      this.clinicSaving = true;

      try {
        const patientsToSave = [...this.clinicSelectedPatients];

        for (const patient of patientsToSave) {
          const payload = {
            ...this.clinicPatientsForm,
            ID_Patient: patient.ID_Patient,
            ID_Customer: this.customerToShow.ID_Customer,
          };

          await this.$API.patientslists.registerPatient(payload);
        }

        this.showAlert(
          "success",
          "Actualmente en clínica",
          "Los pacientes seleccionados fueron agregados correctamente."
        );
        this.clearClinicSelection();
        this.closeClinicModal();
        this.getPatients();
        this.$emit("reloadData");
      } catch (e) {
        console.log(e);
        this.showAlert(
          "danger",
          "Actualmente en clínica",
          "Ocurrió un problema al registrar uno o más pacientes."
        );
      } finally {
        this.clinicSaving = false;
      }
    },

    async saveVeterinaryClinicPatients() {
      if (!this.veterinaryClinicSelectedPatients.length) {
        this.showAlert(
          "warning",
          "Actualmente en clínica",
          "Selecciona al menos un paciente para guardar la visita."
        );
        return;
      }

      this.veterinaryClinicSaving = true;

      try {
        const patientsToSave = [...this.veterinaryClinicSelectedPatients];

        for (const patient of patientsToSave) {
        const payload = {
          ...this.veterinaryClinicPatientsForm,
          ID_Patient: patient.ID_Patient,
          ID_Customer: this.customerToShow.ID_Customer,
          AsignedTo: patient.AsignedTo || this.veterinaryClinicPatientsForm.AsignedTo,
          Weight: patient.Weight || patient.weight || "",
          weight: patient.Weight || patient.weight || "",
          weightunit: patient.weightunit,
        };

          await this.$API.veterinarypatientslists.registerPatient(payload);
        }

        this.showAlert(
          "success",
          "Actualmente en clínica",
          "Los pacientes seleccionados fueron agregados correctamente."
        );
        this.clearVeterinaryClinicSelection();
        this.closeVeterinaryClinicModal();
        this.getVeterinaryPatients();
        this.$emit("reloadData");
      } catch (e) {
        console.log(e);
        this.showAlert(
          "danger",
          "Actualmente en clínica",
          "Ocurrió un problema al registrar uno o más pacientes."
        );
      } finally {
        this.veterinaryClinicSaving = false;
      }
    },

    patientSelected(data) {
      this.$store.dispatch("addWindow", {
        name: "patientData",
        component: "PatientData",
        unique: false,
        meta: { patient: data.data },
      });
    },

    veterinaryPatientSelected(data) {
      data.data.customer = this.customerToShow;
      this.$store.commit("vetPatientData/changeView", "tab-1");
      //this.commit("vetPatientData/changeView", "tab-1")
      this.$store.dispatch("addWindow", {
        name: "VeterinaryPatientData",
        component: "VeterinaryPatientData",
        unique: false,
        meta: { veterinarypatients: data.data, reload: true },
      });
    },
    openUpcomingVaccinesModal(patient) {
      this.selectedUpcomingVaccinesPatient = {
        ...patient,
        customer: this.customerToShow,
      };
      this.showUpcomingVaccinesModal = true;
    },
    filterHandlerPatients(response) {
      this.patients = response;
    },
    filterHandlerVeterinaryPatients(response) {
      this.veterinarypatients = response;
    },
    getAllCustomers() {
      this.$API.customers.getCustomersHistory(this.searchCustomers)
        .then(response => {
         // response = this.prepareCustomersResponse(response);
          this.customers = response;
         /*  console.log('customers all', response); */
        })
    },
    filterHandler(response) {
      this.customers = response;
    },
    handleShowCustomersList(type) {
      this.showCustomersList = true;
      this.customerToMigrate = {
        ID_Customer: null,
        type
      };
      this.patientsToMigrate = [];
      this.selectedPatients = [];
      this.selectAllPatients = false;
      this.showPatientsToMigrateModal = false;
    },
    async customerSelected(id) {
      // Validar que no se pueda seleccionar el mismo cliente
      if (id === this.customerToShow.ID_Customer) {
        this.showCustomersList = false;
        this.showAlert('warning', 'Migrar pacientes', 'No puedes migrar pacientes desde el mismo cliente actual.');
        return;
      }
      this.customerToMigrate.ID_Customer = id;
      // Configurar endpoint y búsqueda según tipo de paciente
      if (this.customerToMigrate.type === 'veterinary') {
        this.patientsToMigrateFilterEndpoint = this.$API.veterinarypatients.getPatientsFiltered;
      } else {
        this.patientsToMigrateFilterEndpoint = this.$API.patients.getPatientsFiltered;
      }
      
      // Configurar búsqueda para pacientes a migrar
      this.patientsToMigrateSearch = {
        customerID: id,
        filter: null,
      };
      this.patientsToMigrate = [];
      this.patientsToMigrateFiltered = [];
      this.selectedPatients = [];
      this.selectAllPatients = false;
      this.showCustomersList = false;
      
      // Cargar pacientes correctamente según tipo
      let res = [];
      if (this.customerToMigrate.type === 'veterinary') {
        res = await this.$API.veterinarypatients.getPatientsHistory({ customer: id });
      } else {
        res = await this.$API.patients.getPatientsHistory({ customer: id });
      }
      this.patientsToMigrate = res || [];
      this.patientsToMigrateFiltered = [...this.patientsToMigrate];

      // Mantener selección si ya había
      this.selectedPatients = this.selectedPatients.filter(pid =>
        this.patientsToMigrate.some(p => p.ID_Patient === pid)
      );
      this.updateSelectAllPatients();
      if (this.patientsToMigrate.length === 0) {
        this.showAlert('warning', 'Migrar pacientes', 'El cliente seleccionado no tiene pacientes para migrar.');
        return;
      }
      this.showPatientsToMigrateModal = true;
    },
    async fetchPatientsToMigrate() {
      
      if (!this.customerToMigrate?.ID_Customer) return;
      let res = [];
      if (this.customerToMigrate.type === 'veterinary') {
        res = await this.$API.veterinarypatients.getPatientsHistory({ customer: this.customerToMigrate.ID_Customer });
      } else {
        res = await this.$API.patients.getPatientsHistory({ customer: this.customerToMigrate.ID_Customer });
      }
      this.patientsToMigrate = res || [];
      this.patientsToMigrateFiltered = [...this.patientsToMigrate];
      this.selectedPatients = this.selectedPatients.filter(id =>
        this.patientsToMigrate.some(p => p.ID_Patient === id)
      );
      this.updateSelectAllPatients();
    },
    filterHandlerPatientsToMigrate(response) {
      this.patientsToMigrateFiltered = response || [];
      this.selectedPatients = this.selectedPatients.filter(id =>
        this.patientsToMigrate.some(p => p.ID_Patient === id)
      );
      this.updateSelectAllPatients();
    },
    toggleSelectAllPatients() {
      if (this.selectAllPatients) {
        const idsToAdd = this.patientsToMigrateFiltered
          .map(p => p.ID_Patient)
          .filter(id => !this.selectedPatients.includes(id));
        this.selectedPatients = [...this.selectedPatients, ...idsToAdd];
      } else {
        const idsToRemove = this.patientsToMigrateFiltered.map(p => p.ID_Patient);
        this.selectedPatients = this.selectedPatients.filter(id => !idsToRemove.includes(id));
      }
    },
    updateSelectAllPatients() {
      // Si todos los pacientes filtrados están seleccionados, marcar el checkbox de "Seleccionar todos"
      if (
        this.patientsToMigrateFiltered.length > 0 &&
        this.patientsToMigrateFiltered.every(p => this.selectedPatients.includes(p.ID_Patient))
      ) {
        this.selectAllPatients = true;
      } else {
        this.selectAllPatients = false;
      }
    },
    closePatientsToMigrateModal() {
      this.showPatientsToMigrateModal = false;
      this.patientsToMigrate = [];
      this.patientsToMigrateFiltered = [];
      this.selectedPatients = [];
      this.selectAllPatients = false;
    },
    async migrateSelectedPatients() {
      if (!this.selectedPatients.length) return;
      try {
        if (this.customerToMigrate.type === 'veterinary') {
          await this.$API.veterinarypatients.migratePatientsByIds({
            newCustomer: this.customerToShow.ID_Customer,
            patientIds: this.selectedPatients
          });
          this.showAlert('success', 'Migrar pacientes', 'Pacientes migrados correctamente.');
          this.getVeterinaryPatients();
        } else if (this.customerToMigrate.type === 'medical') {
          await this.$API.patients.migratePatientsByIds({
            newCustomer: this.customerToShow.ID_Customer,
            patientIds: this.selectedPatients
          });
          this.showAlert('success', 'Migrar pacientes', 'Pacientes migrados correctamente.');
          this.getPatients();
        }
        this.closePatientsToMigrateModal();
      } catch (e) {
        this.showAlert('danger', 'Error', 'Ocurrió un error al migrar los pacientes seleccionados.');
      }
    },
    migratePatients() {
      if(this.customerToMigrate.type == 'veterinary') {
        this.$API.veterinarypatients.migratePatients({ newCustomer: this.customerToShow.ID_Customer , ID_Customer: this.customerToMigrate.ID_Customer })
        .then(() => {
          this.showAlert('success','Migrar pacientes' , `Se migraron correctamente los pacientes del cliente: ${this.customerToMigrate.ID_Customer}`);
          this.getVeterinaryPatients();
          this.customerToMigrate = null;
          this.closePatientsToMigrateModal();
        })
        .catch(() => {
          this.showAlert('warning','Migrar pacientes' , `Ocurrio un error al migrar los pacientes del cliente: ${this.customerToMigrate.ID_Customer}`);
          this.customerToMigrate = null;
        })
      }
      if(this.customerToMigrate.type == 'medical') {
        this.$API.patients.migratePatients({ newCustomer: this.customerToShow.ID_Customer , ID_Customer: this.customerToMigrate.ID_Customer })
        .then(() => {
          this.showAlert('success','Migrar pacientes' , `Se migraron correctamente los pacientes del cliente: ${this.customerToMigrate.ID_Customer}`);
          this.getPatients();
          this.customerToMigrate = null;
          this.closePatientsToMigrateModal();
        })
        .catch(() => {
          this.showAlert('warning','Migrar pacientes' , `Ocurrio un error al migrar los pacientes del cliente: ${this.customerToMigrate.ID_Customer}`);
          this.customerToMigrate = null;
        })
      }
    },
    confirmMigratePatients() {
      this.showPatientsToMigrateModal = false;
      this.$nextTick(() => {
        this.showAlert(
          'question2',
          'Migrar pacientes',
          '¿Está seguro de migrar todos los pacientes de este cliente?',
          'migrateAllPatients'
        );
      });
    },
    confirmMigrateSelectedPatients() {
      this.showPatientsToMigrateModal = false;
      this.$nextTick(() => {
        this.showAlert(
          'question2',
          'Migrar pacientes',
          '¿Está seguro de migrar los pacientes seleccionados de este cliente?',
          'migrateSelectedPatients'
        );
      });
    },
  },
};
</script>

<style scoped>
.btnsave {
  background-color: #00a178 !important;
  color: white;
}
.btnclean {
  background-color: #f29d35 !important;
  color: white;
}
</style>
